import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import LifeInvestmentService from '../../../shared/services/LifeInvestmentService';
import PSGlobalLoading from '../../PSGlobalLoading';
import PSIcon from '../../PSIcon';

import './index.scss';

const PSTablePolicies = () => {
  const history = useHistory();
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const dataPolicies = JSON.parse(localStorage.getItem('policiesVigp')) || [];

  const rowsPerPage = 5;
  const totalPages = Math.ceil(dataPolicies.length / rowsPerPage);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = dataPolicies.slice(indexOfFirstRow, indexOfLastRow);

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const goToPolicyDetail = async (row) => {
    try {
      setIsLoading(true);
      const idTokenPD = localStorage.getItem('idTokenPD');
      const payload = {
        nroPoliza: row.numeroPoliza,
        rol: row.idRol,
      };

      const responsePolicyDetail = await LifeInvestmentService.getPolicyDetail(
        payload
      );

      
      if (!responsePolicyDetail.Success) {
        return;
      }

      localStorage.setItem('policyDetail', JSON.stringify(responsePolicyDetail.Data));
      history.push({
        pathname: `/intranet/product/vidaInversion/${row.numeroPoliza}`,
        state: location.state,
      });
      setIsLoading(false);
    } catch (error) {
      console.error('Error al obtener datos de la póliza:', error);
      setIsLoading(false);
    }
  };

  const formatAmount = (data) => {
    const match = data.match(/^([A-Za-z]+)\s*([\d.,]+)$/);
    if (!match) return data;

    const currency = match[1];
    let amount = match[2];

    amount = amount.replace(/,/g, '');

    const number = parseFloat(amount);

    if (Number.isNaN(number)) return data;

    const formattedNumber = number.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `${currency} ${formattedNumber}`;
  };

  const formatDate = (fechaISO) => {
    if (!fechaISO) return '';

    const fecha = new Date(fechaISO);
    const dia = String(fecha.getDate()).padStart(2, '0');
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const anio = fecha.getFullYear();

    return `${dia}/${mes}/${anio}`;
  };

  return (
    <div className="table-policies">
      {isLoading && <PSGlobalLoading show={isLoading} />}
      <table className="table-policies__container">
        <thead className="table-policies__container--header">
          <tr>
            <th className="font-semibold">Póliza</th>
            <th className="font-semibold">Monto de prima</th>
            <th className="font-semibold">Inicio de vigencia</th>
          </tr>
        </thead>
        <tbody className="table-policies__container--body">
          {currentRows.map((row) => (
            <tr
              key={`${row.id}-${row.rol}`}
              className="policy-item"
              onClick={() => goToPolicyDetail(row)}
            >
              <td>{row.numeroPoliza}</td>
              <td>{formatAmount(row.primaTotal)}</td>
              <td>{formatDate(row.fechaOrigen)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {dataPolicies.length > 5 && (
        <>
          <div className="table-policies__pagination">
            <button type="button" onClick={handlePrev} disabled={currentPage === 1}>
              <PSIcon type="arrowLeftOrange" className="arrow-right" />
            </button>
            <span className="table-policies__pagination--current">{currentPage}</span>
            <button type="button" onClick={handleNext} disabled={currentPage === totalPages}>
              <PSIcon type="arrowRightOrange" className="arrow-left" />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default PSTablePolicies;
